import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

const apply = (theme) => {
  const el = document.documentElement;
  if (theme === "light") el.classList.add("light");
  else el.classList.remove("light");
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("cs_theme") || "dark");

  useEffect(() => {
    apply(theme);
    localStorage.setItem("cs_theme", theme);
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "light" ? "dark" : "light")), []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle, isLight: theme === "light" }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
